import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getAdminLicenseStatsApi,
  computeAdminLicenseStatsApi,
} from "../api/adminLicenseStatsApi";

export const ADMIN_LICENSE_STATS_QUERY_KEY = ["admin", "licenseStats"];

export const useGetAdminLicenseStatsQuery = (
  fromDate: string,
  toDate: string
) => {
  return useQuery({
    queryKey: [...ADMIN_LICENSE_STATS_QUERY_KEY, fromDate, toDate],
    queryFn: () => getAdminLicenseStatsApi(fromDate, toDate),
  });
};

export const useComputeAdminLicenseStatsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: computeAdminLicenseStatsApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_LICENSE_STATS_QUERY_KEY });
    },
  });
};
